module.exports = __webpack_public_path__ + "img/48.a0fe3875.jpg";